<template>
  <el-dialog
    title="待发货订单"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="680px"
  >
    <div style="margin-bottom: 10px">以下待处理订单将自动调拨，或者先处理完订单再调拨</div>
    <el-table :data="list" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column label="订单号" align="center">
        <template slot-scope="{ row }">
          <el-link type="primary" @click="handleClick(row)">{{ row.orderNo }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="下单人" align="center">
        <template slot-scope="{ row }">
          {{row.staffName}}-{{row.staffMobile}}
        </template>
      </el-table-column>
      <el-table-column label="下单时间" align="center" prop="orderTime" />
      <el-table-column label="订单状态" align="center">
        <template slot-scope="{ row }">
          {{optionsFilter(row.state, stateOptions)}}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer"></span>
  </el-dialog>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "OrderDia",
  data() {
    return {
      visible: false,
      loading: false,
      row: {},
      list: [],

      stateOptions: [
        { label: '待确认', value: '00' },
        { label: '已确认', value: '01' },
        { label: '待支付', value: '02' },
        { label: '已绑码', value: '03' },
        { label: '已收货', value: '04' },
        { label: '降价收货', value: '05' },
        { label: '已取消', value: '10' },
        { label: '已作废', value: '20' },
        { label: '已退回', value: '30' },
      ]
    };
  },
  methods: {
    open(row) {
      this.row = row
      this.getList()
      this.visible = true
    },
    getList() {
      const { staffId, allotOrderScope, allotOrderStartTime } = this.row
      _api.allotNoTodoOrderList({
        staffId, allotOrderScope, allotOrderStartTime
      }).then(res => {
        this.list = res.data
      })
    },
    optionsFilter(v, options) {
      return options.find(item => item.value == v)?.label || '--'
    },
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
  }
};
</script>

<style lang="scss" scoped>

</style>